'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getAvatarColor;
function getAvatarColor(name, s, l) {
    var hash = 0;
    for (var i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    var h = hash % 360;
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
}